// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__VgTMF","errorLogs":"styles_errorLogs__1PoUC"};